import { I18nStrings } from './index';

export const es: I18nStrings = {
  cardTitle: (num: number, side: 'front' | 'back') =>
      `Tarjeta ${num} (Lado ${side === 'front' ? 'frontal' : 'trasero'})`,
  insertFlipCard: 'Insertar tarjeta reversible',
  frontSide: 'Lado frontal',
  backSide: 'Lado trasero',
  flipToBack: 'Girar al lado trasero',
  flipToFront: 'Girar al lado frontal',
  clickToFlip: 'Haga clic para girar',
  addText: 'Agregar texto',
  addTextPlaceholder: 'Ingrese su texto...',
  addImage: 'Agregar imagen',
  insertImage: 'Insertar imagen',
  uploadFile: 'Subir archivo',
  urlPlaceholder: 'Introduzca la URL de la imagen...',
  ok: 'OK',
  cancel: 'Cancelar',
  copyCard: 'Copiar tarjeta',
  deleteCard: 'Eliminar tarjeta',
  resetFace: 'Restablecer',
  dragHandle: 'Arrastrar para reorganizar',
  or: 'o'
};

